<template>
    <div id="landing-banner">
        <!--=====================================-->
        <!--=        Banner Area Start         =-->
        <!--=====================================-->
        <section class="banner banner-style-5 mb--100">
            <div class="container p-5">
                <div class="row">
                    <div class="col-12">
                        <div class="banner-content">
                            <h1 class="subtitle primary mb-0" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="100">Red de Compromiso.</h1>
                            <h1 class="title white font-weight-100 text-wrap-balance" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="200">
                                Te premiamos por tu <span class="bold">Compromiso</span>
                                con tus finanzas personales
                                y el medioambiente.
                            </h1>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: "LandingBanner",
    components: {

    }
}

</script>

<style scoped>
.banner-style-5 {
    padding: 200px 40px 0;
    background-image: url("https://cdn.redgirasol.com/nuevo_portal/banners/programa-compromiso/banner-compromiso.png");
}

.banner.banner-style-5::after {
    background-color: transparent;
}
</style>